import WindowManager from '../../window-manager';
import Device from '../../device';
import TrackingHelper from "../helper.js";
/**
 * Page-Landmark. Will be triggered once per page.
 * @param {HTMLElement} element Element which posesses this landmark.
 * @param {object} data Landmark configuration data. Cannot be null.
 * @param {function} sendLandmark Function to send data to the landmark service. Cannot be null.
 */

export default function(element, data, sendLandmark) {
    data.landmark = data.landmark || 'page';
    data.ptabid = WindowManager.getCurrentTabId();
    // PP-889: change the device type to tablet if the device service could not recognise the real device type
    if(data.device === "desktop" && Device.isTouch()) {
        data.device = "tablet";
    }
    data.eventId = TrackingHelper.getPageViewId()
    sendLandmark(data);
}
